module.exports = __webpack_public_path__ + "static/media/gauge_widget.b4164c27.jpg";